import { TableData } from "../../../models/tableData/types";
import { BrandCompany, ExternalProduct } from "../../../models/product/types";
import { ShortTag, TagProductAssociation } from "../../../redux/actions/tagActions/types";

export type TagsTableProps = {
    tableData: TableData;
    setTableData: React.Dispatch<React.SetStateAction<TableData>>;
    totalCount: number;
    tagId: number;
    setSelectedProductIds?: React.Dispatch<React.SetStateAction<number[]>>;
    selectedProductIds?: number[];
};
export enum ProductType {
    FavoriteProduct = 'FavoriteProduct',
    ProjectProduct = 'ProjectProduct',
}

export type TagProductRow = {
    id: number;
    key: number;
    productType: ProductType;
    manufacturer: string;
    productName: string;
    nameSort: string;
    tags: ShortTag[];
    tagsSort: string;
    productCount: number;
    projectLibraryText: string;
    projectLibrarySort: string;
    projectLibraryLink: string;
    catalogUrl?: string;
    dateTagAdded?: string;
    addedBy: string;
    createdAtSortable: string;
};

export type BuildTagProductRowArgs = {
    item: TagProductAssociation;
    externalById: Record<number, ExternalProduct>;
    companyById: Record<number, BrandCompany>;
    organizationName?: string;
};
